<template>
  <div>

    <div class="card">
      <div class="card-body">
        <div class="card-title">
          <h2>
            출석 체크
          </h2>
          <p class="gray">수강 인원에 대한 출석을 체크합니다.</p>
        </div>

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <el-date-picker
              v-model="dayOfWeek"
              type="week"
              format="yyyy년 MM월"
              placeholder="주를 선택하세요."
              :picker-options="pickerOptions"
              @change="retrieve(1)">
            </el-date-picker>
            <div class="input-with-text"><span class="number">{{dateRange}}</span></div>
          </div>
          <div class="text-right mt-3" style="width: 100%; position: absolute;" v-if="this.attendanceData.length > 0">
            <button type="button" class="btn mint text-black" @click="handleSelectionToggle(true)">전체선택</button>
            <button type="button" class="btn white" @click="handleSelectionToggle(false)">전체선택해제</button>
          </div>
        </div>
      </div>

      <el-row :gutter="10">
        <el-col :span="8">
          <el-card shadow="never" v-for="attendance in attendanceData" :key="attendance.attendance_dt" :class="'attendance-date' + (selectedDay === attendance.attendance_dt ? '-selected' : '')" class="no-radius">
            <div v-on:click="rowClickHandler(attendance.attendance_dt)">
              <ul>
                <li class="day"><span class="number">{{`${attendance.tmp_date} (${attendance.tmp_day_name})`}}</span> <el-tag v-if="attendance.tmp_to_day_yn === 'Y'">TODAY</el-tag></li>
                <li class="attendance">{{`출석률 ${attendance.attend_rate}%`}}&nbsp;&nbsp;&nbsp;{{`출석인원 ${attendance.attend_cnt} / ${attendance.total_cnt}`}}</li>
              </ul>
            </div>
          </el-card>
        </el-col>
        <el-col :span="16">
          <data-tables
            class="no-left-margin small-td bg-white"
            :data="classUserData"
            :table-props="tableProps"
            :page-size="emptyPageSize"
            :pagination-props="emptyPaginationProps"
            v-loading="searchLoading">

            <el-table-column label="이미지" width="95" header-align="center" align="center">
              <template slot-scope="scope">
                <b-img :rounded="scope.row.download_url ? 'circle' : '0'" width="75" height="75" alt="img" class="m-1" :src="scope.row.download_url ? scope.row.download_url : '/static/img/profile-tutor.png'" />
              </template>
            </el-table-column>
            <el-table-column label="학생정보" min-width="150" header-align="center">
              <template slot-scope="scope">
                <ul>
                  <li><strong>{{scope.row.user_name}}</strong></li>
                  <li class="attendance">{{`${getValue(scope.row.school_name)} ${scope.row.user_id}`}}</li>
                </ul>
              </template>
            </el-table-column>
            <el-table-column label="출결여부" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button :disabled="scope.row.memo ? true : false" :type="scope.row.attendance_yn === 'Y' ? 'success' : 'info'" icon="el-icon-check" circle @click="changeAttendStat(scope.row)"></el-button>
              </template>
            </el-table-column>
            <el-table-column label="결석사유" min-width="200" header-align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.memo" :disabled="scope.row.attendance_yn === 'Y'" clearable placeholder="결석 사유를 입력하세요"></el-input>
              </template>
            </el-table-column>
          </data-tables>
        </el-col>
      </el-row>
      <div class="card-body text-right">
        <el-button type="default" @click="resetForm">취소</el-button>
        <el-button type="primary" @click="submitForm" :disabled="classUserData.length === 0">저장</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/modules/common'
export default {
  name: 'M020106',
  mixins: [common.mixins],
  data () {
    return {
      dayOfWeek: '',
      pickerOptions: {
        disabledDate: function (time) {
          return time.getTime() > Date.now()
        }
      },
      attendanceData: [],
      search: {
        class_seq: this.$route.params.class_seq
      },
      selectedDay: '',
      classUserData: [],
      tableProps: {showHeader: false, height: this.getScreenHeight(68)},
      dateRange: ''
    }
  },
  beforeCreate () {
    if (this.$route.params.class_seq === undefined || this.$route.params.class_seq === 0) {
      this.$router.push({name: 'M020101'})
    }
  },
  created () {
    this.dayOfWeek = this.getWeekStartDate2(1)
    this.retrieve(0)
  },
  methods: {
    submitForm () {
      let attendanceCount = 0
      let memoCount = 0
      this.classUserData.forEach(row => {
        if (row.attendance_yn === 'Y') {
          attendanceCount++
        }
        if (!this.isEmpty(row.memo)) {
          memoCount++
        }
      })
      if (attendanceCount === 0 && memoCount === 0) {
        this.$confirm('모두 미출석으로 저장하시겠습니까?', '', {
        }).then(() => {
          this.saveAttendance()
        }).catch(() => {
        })
        return
      }
      this.saveAttendance()
    },
    saveAttendance () {
      common.axios.post('/class/attendance/storage', {attendance: this.classUserData})
        .then(response => {
          if (response.data.status === 1) {
            this.$message('저장되었습니다.')
            this.retrieve(2)
          }
        })
        .catch(error => {
          if (error.response.data.errors) {
            error.response.data.errors.map(msg => {
              this.$message.error(msg)
            })
          }
        })
    },
    retrieve (isToday) {
      // isToday 0: 화면 초기값, 1: 달력으로 선택한 날짜, 2: 선택된 날짜
      const startDate = isToday === 0 ? this.getWeekStartDateNew('', 0) : this.getWeekStartDateNew(this.formatterDate(this.dayOfWeek, 'YYYYMMDD'), 0)
      if (!startDate) {
        this.$message.error('주를 선택하세요.')
        return
      }
      this.search.start_dt = startDate
      this.search.end_dt = this.addDays(startDate, 6)
      this.dateRange = this.formatterDate(this.search.start_dt) + ' ~ ' + this.formatterDate(this.search.end_dt)
      common.axios.post('/class/attendance/schedule/list', this.search)
        .then(response => {
          this.attendanceData = response.data
          const attendanceLen = this.attendanceData.length
          if (attendanceLen > 0) {
            let selectedDay = this.attendanceData[0].attendance_dt
            if (isToday === 0) {
              const today = this.formatterDate(new Date(), 'YYYYMMDD')
              if (this.attendanceData.findIndex(x => x.attendance_dt === today) !== -1) {
                selectedDay = today
              }
            } else if (isToday === 2) {
              selectedDay = this.selectedDay
            }
            this.retrieveOneDay(selectedDay)
          } else {
            this.classUserData = []
          }
        })
    },
    retrieveOneDay (attendanceDt) {
      this.selectedDay = attendanceDt
      this.search.attendance_dt = attendanceDt
      this.loadStoneDataTable('/class/attendance/list/' + attendanceDt, this.search)
        .then(response => {
          this.classUserData = response.data
        })
    },
    rowClickHandler (attendanceDt) {
      this.retrieveOneDay(attendanceDt)
    },
    changeAttendStat (obj) {
      if (obj.attendance_yn === 'Y') {
        obj.attendance_yn = 'N'
      } else {
        obj.attendance_yn = 'Y'
        obj.memo = ''
      }
    },
    getValue (value) {
      return !value ? '' : value + ' / '
    },
    resetForm () {
      this.$router.push({name: 'M020103'})
    },
    handleSelectionToggle (isSelected) {
      this.classUserData.forEach(row => {
        row.attendance_yn = isSelected ? 'Y' : 'N'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .day {
    font-size: 1.5em;
    font-weight: bold;
  }
  .attendance {
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #61618a;
  }
  .attendance-date {
    background-color: #ffffff;
    cursor: pointer;
    color: #292955;
  }
  .attendance-date .day .number {
    color: #292955;
  }
  .attendance-date-selected {
    background-color: #e6ebf1;
    cursor: pointer;
    color: #61618a;
  }
  .attendance-date-selected .day .number {
    color: #61618a;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M020106.vue